import PropTypes from 'prop-types';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';

const isFilled = (value) =>
  value !== undefined &&
  value !== null &&
  value !== '' &&
  !(Array.isArray(value) && value.length === 0);

/**
 * Counter of the filled fields of a form card ("4 / 7 renseignés").
 * Only the fields having a `name` are counted.
 * @component
 * @param {Object} props - The component props.
 * @param {Object[]} props.fields - Fields displayed in the card.
 * @returns {JSX.Element} - The FieldsProgress component.
 */
export const FieldsProgress = ({ fields }) => {
  const { t } = useTranslation();
  const countable = (fields || []).filter((field) => field.name);

  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => (
        <span>
          {t('global.filled_count', {
            filled: countable.filter((field) =>
              isFilled(getFieldValue(field.name))
            ).length,
            total: countable.length
          })}
        </span>
      )}
    </Form.Item>
  );
};

FieldsProgress.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({}))
};

FieldsProgress.defaultProps = {
  fields: []
};
